import React, { useState } from "react";
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import loginImage from '../../../assets/login.png';
import { newPasswordService } from '../../../services/forgotPassword/newPassword';
import "./NewPassword.css";

const NewPasswordPage = () => {

    const dispatch = useDispatch();
    const [code, setCode] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Las contraseñas no coinciden',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        const email = localStorage.getItem("encryptedEmail");
        if (!email) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se encontró un email válido',
                confirmButtonText: 'Aceptar'
            }).then(() => {
                window.location.href = '/auth/login';
            });

            return;
        }

        dispatch(newPasswordService(email, code, newPassword))
            .then(response => {
                Swal.fire({
                    icon: 'success',
                    title: 'Contraseña restablecida',
                    text: 'Tu contraseña ha sido actualizada exitosamente.',
                    confirmButtonText: 'Aceptar'
                }).then(() => {
                    localStorage.clear();
                    window.location.href = '/auth/login';
                });
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Ocurrió un error al restablecer la contraseña.',
                    confirmButtonText: 'Aceptar'
                }).then(() => {
                    localStorage.clear();
                    window.location.href = '/auth/login';
                });
            });



    };

    return (
        <div className="main">
            <section className="forgot">
                <div className="container">
                    <div className="forgot-content">
                        <div className="forgot-image">
                            <figure>
                                <img className="imglogin" src={loginImage} alt="descripcion imagen" />
                            </figure>
                        </div>
                        <div className="forgot-form">
                            <h2 className="form-title">Restablecer Contraseña</h2>
                            <form method="POST" className="forgot-password-form" id="forgot-password-form" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="code"><i className="zmdi zmdi-key" /></label>
                                    <input
                                        type="text"
                                        id="code"
                                        placeholder="Ingresa el código"
                                        value={code}
                                        onChange={(e) => setCode(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="newPassword"><i className="zmdi zmdi-lock" /></label>
                                    <input
                                        type="password"
                                        id="newPassword"
                                        placeholder="Nueva Contraseña"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="confirmPassword"><i className="zmdi zmdi-lock-outline" /></label>
                                    <input
                                        type="password"
                                        id="confirmPassword"
                                        placeholder="Confirmar Nueva Contraseña"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                    />
                                </div>

                                <div className="form-group form-button">
                                    <button type="submit" className="form-submit">
                                        Restablecer Contraseña
                                    </button>
                                </div>
                            </form>
                            <div className="social-login">
                                <ul className="socials">
                                    <li><button className="buttonhref"><i className="display-flex-center zmdi zmdi-facebook" /></button></li>
                                    <li><button className="buttonhref"><i className="display-flex-center zmdi zmdi-twitter" /></button></li>
                                    <li><button className="buttonhref"><i className="display-flex-center zmdi zmdi-google" /></button></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default NewPasswordPage;